import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const getDataSets = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/dataset/client/${clientID}`;
  console.log("!!! FETCHING data SETS WITH URL: ", url);
  console.log("!!! USING TOKEN: ", getIDToken());
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("data SET ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  return results;
};

export const getDataSet = async (dataSetID) => {
  const url = `${config.REST_SERVER_URL}/admin/dataset/${dataSetID}`;
  console.log("!!! FETCHING data SET WITH URL: ", url);
  console.log("!!! USING TOKEN: ", getIDToken());
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("data SET ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  return results;
}

export const saveDataSet = async (dataSetData, clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/dataset/${dataSetData.public_id ? dataSetData.public_id : ""}`;
  console.log("!!! SAVING data SET WITH URL: ", url);
  console.log("!!! USING TOKEN: ", getIDToken());
  const response = await fetch(url, {
    method: dataSetData.public_id ? "PUT" : "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({
      ...dataSetData,
      client_id: clientID,
    }),
  }).catch((error) => {
    console.log("SAVE data SET ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! SAVE RESULTS: ", results);
  return results;
};

export const queryDataSet = (dataSetID, query, queryType, docCount) => {
  const url = `${config.REST_SERVER_URL}/admin/dataset/query/${dataSetID}`;
  console.log("!!! QUERYING data SET WITH URL: ", url);
  console.log("!!! USING TOKEN: ", getIDToken());
  return fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({
      query,
      query_type: queryType,
      doc_count: docCount,
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.log("QUERY data SET ERROR: ", error);
    });
}

